module.exports = __webpack_public_path__ + "img/close-icon-small.0749edd3.png";